import { render, staticRenderFns } from "./WarehouseTabReturn.vue?vue&type=template&id=46dbfa4d&scoped=true"
import script from "./WarehouseTabReturn.vue?vue&type=script&lang=js"
export * from "./WarehouseTabReturn.vue?vue&type=script&lang=js"
import style0 from "./WarehouseTabReturn.vue?vue&type=style&index=0&id=46dbfa4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dbfa4d",
  null
  
)

export default component.exports